import React, { useState, useEffect, useCallback } from 'react';
import { workflowsApi } from '../services/api';

const fmtDuration = (min) => {
  const m = Number(min) || 0;
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60), r = m % 60;
  return r ? `${h} h ${r}` : `${h} h`;
};

// Initiales (2 lettres) dérivées du nom pour la pastille de la rangée
const initials = (name) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '•';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

export default function WorkflowTemplateList({ user, editMode, isSuperAdmin, onEdit, onLaunch }) {
  const [templates, setTemplates] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await workflowsApi.listTemplates({
        search: search || undefined,
        category: categoryFilter || undefined,
      });
      setTemplates(data.templates || []);
    } catch (e) {
      console.error('Erreur chargement modèles', e);
    } finally {
      setLoading(false);
    }
  }, [search, categoryFilter]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    workflowsApi.getCategories().then(({ data }) => setCategories(data.categories || [])).catch(() => {});
  }, []);

  const handleDuplicate = async (id, e) => {
    e.stopPropagation();
    try { await workflowsApi.duplicateTemplate(id); load(); }
    catch { alert('Échec de la duplication'); }
  };
  const handleDelete = async (id, name, e) => {
    e.stopPropagation();
    if (!window.confirm(`Archiver le modèle « ${name} » ?`)) return;
    try { await workflowsApi.deleteTemplate(id); load(); }
    catch { alert('Échec de la suppression'); }
  };

  if (loading) return <div className="wf-wide"><div className="wf-loading">Chargement…</div></div>;

  return (
    <div className="wf-wide">
      {templates.length === 0 ? (
        <>
          <div className="wf-panel"><div className="page-toolbar">
            <input className="page-search" placeholder="🔍 Rechercher..." value={search} onChange={(e) => setSearch(e.target.value)} />
            <select className={`page-select ${categoryFilter ? 'active-filter' : ''}`} value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
              <option value="">Toutes les catégories</option>
              {categories.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div></div>
          <div className="empty-state">
            <p>Aucun modèle de workflow.</p>
            <p className="wf-muted">Créez votre premier processus avec « + Nouveau modèle ».</p>
          </div>
        </>
      ) : (
        <div className="wf-panel">
          <div className="page-toolbar">
            <input className="page-search" placeholder="🔍 Rechercher..." value={search} onChange={(e) => setSearch(e.target.value)} />
            <select className={`page-select ${categoryFilter ? 'active-filter' : ''}`} value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
              <option value="">Toutes les catégories</option>
              {categories.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          {templates.map((t) => {
            const color = t.category_color || '#0891b2';
            return (
              <div key={t.id} className="wf-tpl-row" onClick={() => onEdit(t.id)}>
                <span className="wf-tpl-icon" style={{ background: color }}>{initials(t.name)}</span>
                <div className="wf-tpl-main">
                  <div className="wf-tpl-name">
                    {t.name}
                    {t.category && <span className="wf-tpl-cat" style={{ background: color + '1f', color }}>{t.category}</span>}
                  </div>
                  <div className="wf-tpl-sub">
                    <span>{t.step_count} étape{t.step_count > 1 ? 's' : ''}</span>
                    <span>{fmtDuration(t.total_estimated_minutes)}</span>
                    {t.societe && <span>{t.societe}</span>}
                    {Number(t.running_count) > 0 && <span className="wf-tpl-running">{t.running_count} en cours</span>}
                  </div>
                </div>
                <div className="wf-tpl-actions" onClick={(e) => e.stopPropagation()}>
                  <button className="btn-icon" title="Lancer" onClick={() => onLaunch(t.id)}>▶️</button>
                  <button className="btn-icon" title="Dupliquer" onClick={(e) => handleDuplicate(t.id, e)}>📑</button>
                  {editMode && isSuperAdmin && (
                    <button className="btn-icon delete" title="Archiver" onClick={(e) => handleDelete(t.id, t.name, e)}>🗑️</button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
